import {TOGGLE} from '@drivesally/sally-fw/lib/inputTypes';

// Attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TOGGLE,
  attribute: 'requires_emissions',
  label: {
    default: 'Requires Emissions',
    short: 'Emissions',
  },
});
